import { render, staticRenderFns } from "./batchImportInv.vue?vue&type=template&id=bcc83996&scoped=true&"
import script from "./batchImportInv.vue?vue&type=script&lang=js&"
export * from "./batchImportInv.vue?vue&type=script&lang=js&"
import style0 from "./batchImportInv.vue?vue&type=style&index=0&id=bcc83996&prod&scoped=true&lang=css&"
import style1 from "./batchImportInv.vue?vue&type=style&index=1&id=bcc83996&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc83996",
  null
  
)

export default component.exports